import { useRouteShare } from 'routes';

import { IconButton } from 'components/Blocks';
import { LinkIcon } from 'components/Icons';

export function SuggestionLink({ suggestionId }: { suggestionId: string }) {
  const shareSuggestion = useRouteShare('userSuggestions');

  return (
    <IconButton
      tooltipContent="Copy Link"
      onClick={() =>
        shareSuggestion({
          suggestionId,
        })
      }
    >
      <LinkIcon size={14} />
    </IconButton>
  );
}
